import { init } from '@sentry/vue'
import {
  shouldLogError,
  isInjectedThirdPartyError,
  isChromeIosInjectedNoise,
  getAdditionalErrorData,
  updateWasLoggedToSentry,
  suppressVueRouterErrors,
  ENVIRONMENTS_WITH_SENTRY_DISABLED,
} from '~/utils/error-handling'
import { logger } from '~/utils/sentry/client-only-logger'

export default defineNuxtPlugin((nuxtApp) => {
  // We ignore [Vue Router warn] to keep pod logs clean
  // https://github.com/nuxt/nuxt/issues/23539 (In Nuxt each 404 is logged 8+ times)
  suppressVueRouterErrors()

  const {
    public: { sentry },
  } = useRuntimeConfig()

  // SSR Errors rendering errors
  nuxtApp.hook('app:error', (error) => {
    logger.error(error, {
      additionalData: getAdditionalErrorData({
        errorHandler: 'app:error hook',
      }),
    })
  })

  // Any vue errors propogated to the top
  nuxtApp.hook('vue:error', (error) => {
    logger.error(error, {
      additionalData: getAdditionalErrorData({
        errorHandler: 'vue:error hook',
      }),
    })
  })

  if (ENVIRONMENTS_WITH_SENTRY_DISABLED.includes(sentry.environment)) {
    return
  }

  if (!sentry.dsn) {
    // eslint-disable-next-line no-console
    console.error('Sentry DSN not set (client), skipping Sentry initialization')
    return
  }

  init({
    beforeSend(event, hint) {
      if (isInjectedThirdPartyError(event) || isChromeIosInjectedNoise(event)) {
        return null
      }

      const error = hint.originalException
      if (!shouldLogError(error)) {
        return null
      }
      // we do not want to log an error twice,
      // so we mark it with wasLoggedToSentry: true
      updateWasLoggedToSentry(hint.originalException, true)
      return event
    },
    app: nuxtApp.vueApp,
    dsn: sentry.dsn,
    environment: sentry.environment,
    integrations: [],
  })
})
